module.exports = __webpack_public_path__ + "static/media/AoA_RaceGameEnvShot_13.62fb02a5.jpg";